import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.hard-token-management.edit.registration', {
        url: '/registration',
        component: 'editHardTokenRegistration',
        resolve: {regEmailData}
    });
}
/** @ngInject */
function regEmailData(HardTokenService,token) {
		
		return HardTokenService.getRegEmailData(token);
}




// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-edit/registration/hard-token-registration.state.js